module.exports = __webpack_public_path__ + "img/j.0f04df6c.jpg";